import { QueryClient } from '@tanstack/query-core';

const STALE_TIME = 0; // No caching by default
const IS_TEST = process.env.NODE_ENV === 'test';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: IS_TEST ? Infinity : undefined,
      retry: false,
      staleTime: STALE_TIME
    }
  }
});

export { queryClient };
